(function (logoView, $) {
  var logo;
  var bubbleHolder;
  var isPaused = false;

  logoView.init = function () {
    logo = $("#electric-labs-logo");
    bubbleHolder = $("#bubble-holder");

    startBubbleAnimations();

    $("#electric-labs-logo-colour-background")
      .delay(1000)
      .addClass("el-liquid-animated el-liquid-fade")
      .one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function () {
        $("#electric-labs-logo-green-liquid-mask-top").fadeIn();
      });

    wireEvents();
  };

  function wireEvents() {
    $("#electric-labs-logo").click(function () {
      $("#electric-labs-logo").toggleClass("el-animation-paused");
    });
  }

  logoView.pauseAnimations = function () {
    if (!isPaused) {
      logo.addClass("el-animation-paused");
      isPaused = true;
    }
  };

  logoView.resumeAnimations = function () {
    if (isPaused) {
      logo.removeClass("el-animation-paused");
      isPaused = false;
    }
  };

  function startBubbleAnimations() {
    for (var i = 0; i < 13; i++) {
      (function (index) {
        setTimeout(function () {
          var isTiny = index < 4;
          animateNewBubble(isTiny);
        }, index * 500);
      })(i);
    }
  }

  function animateNewBubble(isTiny) {
    var bubble = $('<span class="bubble"></span>');
    if (isTiny) {
      bubble.addClass("bubble-tiny");
    } else {
      bubble.addClass("bubble-" + _.sample(["tiny", "small", "medium", "large"]));
    }
    bubbleHolder.append(bubble);

    var animClass = "el-bubble-anim-" + (Math.floor(Math.random() * 2) + 1); // Random number between 1 and 2;
    bubble.css("left", Math.floor(Math.random() * 40) + 30 + "%");
    bubble.css("opacity", 1 - (Math.random() + 0.1));

    bubble
      .addClass(animClass)
      .one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function () {
        bubble.remove();
        animateNewBubble(false);
      });
  }
})((window.el.LogoView = window.el.LogoView || {}), jQuery);
